module.exports = __webpack_public_path__ + "static/media/notes-medical.65124d20.svg";